import React from "react";
import {$} from "../../../../../vendor";
import NewClientDocButton from "./NewClientDocButton";
import SidebarMenu from "../../reservations/components/SidebarMenu";

const ClientDocsSidebar = (props) => {
    const { rbac, t, Biscuit, name } = props;
    const onToggleLeftBar = (ev) => {

        $('#inb-c-sidebar').toggleClass('open');
        $('html,body').scrollTop(0);
    };

    return (<>
        <aside
            id="inb-c-sidebar"
            className="reservations-sidebar"
            style={{float: 'left'}}>
            <header className="inb-c-left-bar__title">
                <h1 className="inb-page-title">
                    {name}
                </h1>
            </header>
        {rbac.hasPermission('write') &&
            <footer
                className="inb-c-left-bar__footer small-only-float-container"
                data-inb-action-link="write">
                <a href="#"
                   id="toggle-left-bar"
                   className="button secondary show-for-small-only" onClick={(e) => onToggleLeftBar(e)}>
                    <i className="fi fi-filter"> </i>
                    <span className="show-for-sr">{t('open_filter_menu')}</span>
                </a>
                <NewClientDocButton
                    t={t}
                    Biscuit={Biscuit}
                />
            </footer>
        }
        </aside>
    </>)
}
export default ClientDocsSidebar;